import { createContext, useContext } from 'react'
import { type ClickToTextListStore } from 'pages/clickToText/pages/all/store'

export const ClickToTextListContext = createContext<ClickToTextListStore | null>(null)

export const useClickToTextListContext = () => {
  const context = useContext(ClickToTextListContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ClickToTextListContext')

  return context
}
